// package: user
// file: user/model.proto

import * as common_permission from "../common/permission";
import * as common_app from "../common/app";
import * as membership_model from "../membership/model";
import * as user_base_model from "../user/base/model";

export const UserInfoV2 = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.userNum != null) {
            if (object.userNum !== "") {
                message.userNum = String(object.userNum);
            }
        }
        if (object.nickname != null) {
            if (object.nickname !== "") {
                message.nickname = String(object.nickname);
            }
        }
        if (object.avatar != null) {
            if (object.avatar !== "") {
                message.avatar = String(object.avatar);
            }
        }
        if (object.character != null) {
            if (object.character !== 0) {
                message.character = object.character;
            }
        }
        if (object.phone != null) {
            if (object.phone !== "") {
                message.phone = String(object.phone);
            }
        }
        if (object.hasBought != null) {
            if (object.hasBought !== false) {
                message.hasBought = Boolean(object.hasBought);
            }
        }
        if (object.hasBoundTaobao != null) {
            if (object.hasBoundTaobao !== false) {
                message.hasBoundTaobao = Boolean(object.hasBoundTaobao);
            }
        }
        if (object.taobaoNicknames != null) {
            if (!Array.isArray(object.taobaoNicknames)) {
                throw TypeError("taobaoNicknames: array expected");
            }
            if (object.taobaoNicknames.length > 0) {
                message.taobaoNicknames = [];
                for (let i = 0; i < object.taobaoNicknames.length; ++i) {
                    message.taobaoNicknames[i] = String(object.taobaoNicknames[i]);
                }
            }
        }
        if (object.hasRegisteredInApp != null) {
            if (object.hasRegisteredInApp !== false) {
                message.hasRegisteredInApp = Boolean(object.hasRegisteredInApp);
            }
        }
        if (object.firstActiveTimeInApp != null) {
            if (object.firstActiveTimeInApp !== 0) {
                message.firstActiveTimeInApp = object.firstActiveTimeInApp | 0;
            }
        }
        if (object.lastActiveTimeInApp != null) {
            if (object.lastActiveTimeInApp !== 0) {
                message.lastActiveTimeInApp = object.lastActiveTimeInApp | 0;
            }
        }
        if (object.createdAt != null) {
            if (object.createdAt !== 0) {
                message.createdAt = object.createdAt | 0;
            }
        }
        if (object.updatedAt != null) {
            if (object.updatedAt !== 0) {
                message.updatedAt = object.updatedAt | 0;
            }
        }
        if (object.membershipInfo != null) {
            message.membershipInfo = membership_model.MembershipInfo.encode(object.membershipInfo);
        }
        if (object.permissions != null) {
            if (!Array.isArray(object.permissions)) {
                throw TypeError("permissions: array expected");
            }
            if (object.permissions.length > 0) {
                message.permissions = [];
                for (let i = 0; i < object.permissions.length; ++i) {
                    message.permissions[i] = object.permissions[i];
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            userNum: "",
            nickname: "",
            avatar: "",
            character: 0,
            phone: "",
            hasBought: false,
            hasBoundTaobao: false,
            taobaoNicknames: [],
            hasRegisteredInApp: false,
            firstActiveTimeInApp: 0,
            lastActiveTimeInApp: 0,
            createdAt: 0,
            updatedAt: 0,
            membershipInfo: null,
            permissions: [],
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.userNum != null) {
            object.userNum = message.userNum;
        }
        if (message.nickname != null) {
            object.nickname = message.nickname;
        }
        if (message.avatar != null) {
            object.avatar = message.avatar;
        }
        if (message.character != null) {
            object.character = message.character;
        }
        if (message.phone != null) {
            object.phone = message.phone;
        }
        if (message.hasBought != null) {
            object.hasBought = message.hasBought;
        }
        if (message.hasBoundTaobao != null) {
            object.hasBoundTaobao = message.hasBoundTaobao;
        }
        if (message.taobaoNicknames != null) {
            object.taobaoNicknames = [];
            for (let i = 0; i < message.taobaoNicknames.length; ++i) {
                    object.taobaoNicknames[i] = message.taobaoNicknames[i];
            }
        }
        if (message.hasRegisteredInApp != null) {
            object.hasRegisteredInApp = message.hasRegisteredInApp;
        }
        if (message.firstActiveTimeInApp != null) {
            object.firstActiveTimeInApp = message.firstActiveTimeInApp;
        }
        if (message.lastActiveTimeInApp != null) {
            object.lastActiveTimeInApp = message.lastActiveTimeInApp;
        }
        if (message.createdAt != null) {
            object.createdAt = message.createdAt;
        }
        if (message.updatedAt != null) {
            object.updatedAt = message.updatedAt;
        }
        if (message.membershipInfo != null) {
            object.membershipInfo = membership_model.MembershipInfo.decode(message.membershipInfo);
        }
        if (message.permissions != null) {
            object.permissions = [];
            for (let i = 0; i < message.permissions.length; ++i) {
                    object.permissions[i] = message.permissions[i];
            }
        }
        return object;
    },
};

export const UserInfoV3 = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.userNum != null) {
            if (object.userNum !== "") {
                message.userNum = String(object.userNum);
            }
        }
        if (object.nickname != null) {
            if (object.nickname !== "") {
                message.nickname = String(object.nickname);
            }
        }
        if (object.avatar != null) {
            if (object.avatar !== "") {
                message.avatar = String(object.avatar);
            }
        }
        if (object.character != null) {
            if (object.character !== 0) {
                message.character = object.character;
            }
        }
        if (object.phone != null) {
            if (object.phone !== "") {
                message.phone = String(object.phone);
            }
        }
        if (object.hasBought != null) {
            if (object.hasBought !== false) {
                message.hasBought = Boolean(object.hasBought);
            }
        }
        if (object.hasBoundTaobao != null) {
            if (object.hasBoundTaobao !== false) {
                message.hasBoundTaobao = Boolean(object.hasBoundTaobao);
            }
        }
        if (object.taobaoNicknames != null) {
            if (!Array.isArray(object.taobaoNicknames)) {
                throw TypeError("taobaoNicknames: array expected");
            }
            if (object.taobaoNicknames.length > 0) {
                message.taobaoNicknames = [];
                for (let i = 0; i < object.taobaoNicknames.length; ++i) {
                    message.taobaoNicknames[i] = String(object.taobaoNicknames[i]);
                }
            }
        }
        if (object.hasRegisteredInApp != null) {
            if (object.hasRegisteredInApp !== false) {
                message.hasRegisteredInApp = Boolean(object.hasRegisteredInApp);
            }
        }
        if (object.firstActiveTimeInApp != null) {
            if (object.firstActiveTimeInApp !== 0) {
                message.firstActiveTimeInApp = String(object.firstActiveTimeInApp);
            }
        }
        if (object.lastActiveTimeInApp != null) {
            if (object.lastActiveTimeInApp !== 0) {
                message.lastActiveTimeInApp = String(object.lastActiveTimeInApp);
            }
        }
        if (object.createdAt != null) {
            if (object.createdAt !== 0) {
                message.createdAt = String(object.createdAt);
            }
        }
        if (object.updatedAt != null) {
            if (object.updatedAt !== 0) {
                message.updatedAt = String(object.updatedAt);
            }
        }
        if (object.membershipInfo != null) {
            message.membershipInfo = membership_model.MembershipInfoV2.encode(object.membershipInfo);
        }
        if (object.permissions != null) {
            if (!Array.isArray(object.permissions)) {
                throw TypeError("permissions: array expected");
            }
            if (object.permissions.length > 0) {
                message.permissions = [];
                for (let i = 0; i < object.permissions.length; ++i) {
                    message.permissions[i] = object.permissions[i];
                }
            }
        }
        if (object.hasBoundWechat != null) {
            if (object.hasBoundWechat !== false) {
                message.hasBoundWechat = Boolean(object.hasBoundWechat);
            }
        }
        if (object.wechatNickname != null) {
            if (object.wechatNickname !== "") {
                message.wechatNickname = String(object.wechatNickname);
            }
        }
        if (object.app != null) {
            if (object.app !== 0) {
                message.app = object.app;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            userNum: "",
            nickname: "",
            avatar: "",
            character: 0,
            phone: "",
            hasBought: false,
            hasBoundTaobao: false,
            taobaoNicknames: [],
            hasRegisteredInApp: false,
            firstActiveTimeInApp: 0,
            lastActiveTimeInApp: 0,
            createdAt: 0,
            updatedAt: 0,
            membershipInfo: null,
            permissions: [],
            hasBoundWechat: false,
            wechatNickname: "",
            app: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.userNum != null) {
            object.userNum = message.userNum;
        }
        if (message.nickname != null) {
            object.nickname = message.nickname;
        }
        if (message.avatar != null) {
            object.avatar = message.avatar;
        }
        if (message.character != null) {
            object.character = message.character;
        }
        if (message.phone != null) {
            object.phone = message.phone;
        }
        if (message.hasBought != null) {
            object.hasBought = message.hasBought;
        }
        if (message.hasBoundTaobao != null) {
            object.hasBoundTaobao = message.hasBoundTaobao;
        }
        if (message.taobaoNicknames != null) {
            object.taobaoNicknames = [];
            for (let i = 0; i < message.taobaoNicknames.length; ++i) {
                    object.taobaoNicknames[i] = message.taobaoNicknames[i];
            }
        }
        if (message.hasRegisteredInApp != null) {
            object.hasRegisteredInApp = message.hasRegisteredInApp;
        }
        if (message.firstActiveTimeInApp != null) {
            object.firstActiveTimeInApp = parseInt(message.firstActiveTimeInApp, 10);
        }
        if (message.lastActiveTimeInApp != null) {
            object.lastActiveTimeInApp = parseInt(message.lastActiveTimeInApp, 10);
        }
        if (message.createdAt != null) {
            object.createdAt = parseInt(message.createdAt, 10);
        }
        if (message.updatedAt != null) {
            object.updatedAt = parseInt(message.updatedAt, 10);
        }
        if (message.membershipInfo != null) {
            object.membershipInfo = membership_model.MembershipInfoV2.decode(message.membershipInfo);
        }
        if (message.permissions != null) {
            object.permissions = [];
            for (let i = 0; i < message.permissions.length; ++i) {
                    object.permissions[i] = message.permissions[i];
            }
        }
        if (message.hasBoundWechat != null) {
            object.hasBoundWechat = message.hasBoundWechat;
        }
        if (message.wechatNickname != null) {
            object.wechatNickname = message.wechatNickname;
        }
        if (message.app != null) {
            object.app = message.app;
        }
        return object;
    },
};


